module.exports = __webpack_public_path__ + "img/green.94990c40.svg";